import styled from "@emotion/styled";
import { DatePicker } from "@mantine/dates";

export const BaseDatePicker = styled(DatePicker)`
  .mantine-DatePicker-monthCell:last-child > button[data-weekend="true"] {
    color: blue;
  }
`;
